// Components==============
import Modal from 'components/UI/Modal/Modal';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
// import { TranslateType } from 'typings';
import Button from '../Button/Button';
import './DeleteMessageModal.module.scss';
// =========================

export default function DeleteMessageModal({
  setModalIsOpen,
  message,
  handleDelete,
}: {
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  message: MessageEntity | FeedbackEntity;
  handleDelete: (id: number) => void;
}) {
  const translate = useTranslate();

  return (
    <Modal setModalIsOpen={setModalIsOpen} size="medium">
      <h1 styleName="title">
        {translate('project.actions.delete-message-title')}
      </h1>
      <div styleName="content">
        <p>{translate('project.actions.delete-message-description')}</p>
        <div styleName="button-wrapper">
          {/* Cancel */}
          <Button color="grey" onClick={() => setModalIsOpen(false)}>
            {translate('general.terms.cancel')}
          </Button>
          {/* Delete */}
          <Button
            onClick={() => {
              handleDelete(message.id);
              setModalIsOpen(false);
              console.log(message);
            }}
          >
            {translate('project.actions.delete-message')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
